// FB 7874 Removed unused imports
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { LoadingButton } from "@mui/lab";
import { Box, Button, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, ThemeProvider, Tooltip, useMediaQuery } from "@mui/material";
import { useContext, useState } from "react";
import { DisablePatient, FindPatients } from "../../../api";
import UseStyle from "../../../css/styles";
import { Patient } from "../../../store";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
// FB 7874
import { LockResetOutlined, RemoveCircleOutline } from "@mui/icons-material";
import { UserContext } from "../../../App";
import Configurations from "../../../config";
import Settings from "../../User/Home/AccountSettings/Settings";

// Update log
// FB  7045   07/19/2023  KK  PP- Unable to enter Date fields manually
// FB  7874   12/07/2023  DK  Admin should be able to access patient pages
// FB  8204   02/01/2024  MS  Added PatientID

export default function FindPatient() {
    var JSAlert = require("js-alert");
    const matches = useMediaQuery("(min-width:600px)");
    const theme = createTheme({
        palette: {
            primary: {
                main: "#18a2b8",
            },
        },
    });
    const styles = UseStyle();
    const [DOB, setDOB] = useState<Date | null>(null);
    const [patientDemographics, setPatientDemographics] = useState<Patient>({} as Patient);
    const [patients, setPatients] = useState<Patient[]>([]);
    const [selectedPatient, setSelectedPatient] = useState<Patient>();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [rowsArray, setRowsArray] = useState([5, 10, 15, 20]);
    const [loaderArray, setLoaderArray] = useState<Array<string>>([]);
    const [open, setOpen] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleInputChange = (e: any) => {
        setPatientDemographics({
            ...patientDemographics,
            [e.target.name]: e.target.value,
        });
    };
    const handleDateChange = async (date: any) => {
        if (date != null && date != "Invalid Date") {
            setDOB(date);
        }
    };
    const handleFind = async () => {
        let date_param = "";
        if (DOB != null) {
            let date = new Date(DOB);
            date_param = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        }
        let patients = await FindPatients(patientDemographics, date_param);
        setShowTable(true);
        if (patients != undefined && patients.length > 0) {
            setPatients(patients);
            setPage(0);
        } else {
            setPatients([]);
        }
    }
    // FB 7874 - Start
    const context = useContext(UserContext);
    const [showSpinner, setShowSpinner] = useState(false);
    const [openResetDialog, setOpenResetDialog] = useState(false);

    async function LoadPatientInfo(user: Patient) {
        setShowSpinner(true);
        const targetUrl = Configurations.API + "/api/patient/Authenticate?userName=" +
            user.Login + "&password=" + encodeURIComponent(user.PatientPassword) +
            "&websiteID=" + user.WebSiteID;
        const config = {
            method: "POST",
        };

        await fetch(targetUrl, config).then(async (response) => {
            if (response.ok) {
                const result = await response.text();
                if (result != null) {
                    sessionStorage.setItem("PP_Auth_Token", result);

                    let data = {
                        Login: user.Login,
                        Patient_n: user.Patient_N,
                        EMRID: user.EMRID,
                        PatientFirstName: user.PatientFirstName,
                        PatientLastName: user.PatientLastName,
                        PatientZIP: user.PatientZIP,
                        PatientDOB: user.PatientDOB,
                        PatientGender: user.PatientGender,
                        IsGuardian: false,
                        Guardian: "",
                        Password: user.PatientPassword
                    };
                    // let dataph = {
                    //     PatientFirstName: user.PatientFirstName,
                    //     PatientLastName: user.PatientLastName,
                    //     PatientZIP: user.PatientZIP,
                    //     PatientDOB: new Date(user.PatientDOB).toLocaleDateString("en-ZA"),
                    //     PatientGender: data.PatientGender == "male" ? 1 : 2,
                    // };

                    // GetPharmacySession(dataph);
                    sessionStorage.setItem("user", JSON.stringify(data));
                    context.setUserLoggedIn(true);
                }
            } else {
                var JSAlert = require("js-alert");
                JSAlert.alert(
                    "Patient data retrieval failed!",
                    null,
                    JSAlert.Icons.Failed
                );
            }
        });

        setSelectedPatient(user);
        setLoaderArray([...loaderArray, user.Patient_N]);
        setOpen(true);
        setLoaderArray(loaderArray.filter((la) => la != user.Patient_N));
        setShowSpinner(false);
        // FB 7874 - End
    }

    async function DisablePatients(patient: Patient) {
        let result = await DisablePatient(Number(patient.Patient_N));
        if (result != null && result != undefined) {
            JSAlert.alert(result, null, JSAlert.Icons.Success).then(function () {
                window.location.reload();
            });
        }
    }

    // FB 7874
    async function ResetPassword(user: Patient) {
        const targetUrl = Configurations.API + "/api/patient/Authenticate?userName=" +
            user.Login + "&password=" + encodeURIComponent(user.PatientPassword) +
            "&websiteID=" + user.WebSiteID;
        const config = {
            method: "POST",
        };

        await fetch(targetUrl, config).then(async (response) => {
            if (response.ok) {
                const result = await response.text();
                if (result != null) {
                    sessionStorage.setItem("PP_Auth_Token", result);
                }
            }
        });

        let data = {
            Login: user.Login,
            Patient_n: user.Patient_N,
            EMRID: user.EMRID,
            PatientFirstName: user.PatientFirstName,
            PatientLastName: user.PatientLastName,
            PatientZIP: user.PatientZIP,
            PatientDOB: user.PatientDOB,
            PatientGender: user.PatientGender,
            IsGuardian: false,
            Guardian: "",
            Password: user.PatientPassword
        };
        sessionStorage.setItem("user", JSON.stringify(data));
        setOpenResetDialog(true);
    }


    return (
        <Box
            sx={
                matches == false
                    ? {
                        width: "100%",
                        padding: "16px",
                        //paddingTop: "16px",
                        //backgroundColor: "#F5F5F5",
                        minHeight: "70vh",
                    }
                    : {
                        width: "100%",
                        padding: "24px 80px 24px 80px",
                        //marginTop: "24px",
                        //backgroundColor: "#F5F5F5",
                        minHeight: "70vh",
                    }
            }
        >
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
                    <TextField
                        id="PatientFirstName"
                        name="PatientFirstName"
                        label="First Name"
                        value={patientDemographics.PatientFirstName}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
                    <TextField
                        id="PatientLastName"
                        name="PatientLastName"
                        label="Last Name"
                        value={patientDemographics.PatientLastName}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
                    {/* FB 7045 KK Begin */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <ThemeProvider theme={theme}>
                            <KeyboardDatePicker
                                InputLabelProps={{ shrink: true }}
                                id="PatientDOB"
                                name="PatientDOB"
                                label="Date of Birth"
                                className={styles.datepickerroot}
                                value={DOB}
                                format="MM/dd/yyyy"
                                placeholder="MM/dd/yyyy"
                                openTo="year"
                                views={["year", "month", "date"]}
                                onChange={(date) => handleDateChange(date)}
                                inputVariant="standard"
                                orientation="portrait"
                                disableFuture
                                required
                                fullWidth
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                    {/* FB 7045 KK End */}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">
                            Gender
                        </FormLabel>
                        <RadioGroup
                            row
                            name="PatientGender"
                            id="PatientGender"
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            onChange={handleInputChange}
                            value={patientDemographics.PatientGender}
                        >
                            <FormControlLabel value="male" control={<Radio />} label="Male" />
                            <FormControlLabel value="female" control={<Radio />} label="Female" />
                            <FormControlLabel value="unknown" control={<Radio />} label="Unknown" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        onClick={handleFind}
                        className={styles.navigationButton}
                        sx={{ mt: 3 }}
                    >
                        Find Patient
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ display: showTable ? "block" : "none" }}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            maxHeight: 400,
                            //maxWidth: matches == false ? "auto" : "90%",
                            borderRadius: 0,
                        }}
                    >
                        <Table
                            id="patient_table"
                            stickyHeader
                            size="small"
                            aria-label="sticky table"
                        //style={{ tableLayout: "fixed" }}
                        >
                            <TableHead>
                                {patients.length > 0 ?
                                    <TableRow>
                                        <TableCell>
                                            <b>Last Name</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>First Name</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>DOB</b>
                                        </TableCell>
                                        {/* FB 8204 BEGIN */}
                                        <TableCell>
                                            <b>Patient ID</b>
                                        </TableCell>
                                        {/* FB 8204 END */}
                                        <TableCell>
                                            <b>Gender</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>E-mail</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>Cell Phone</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>Tools</b>
                                        </TableCell>
                                    </TableRow> :
                                    <TableRow>
                                    </TableRow>
                                }
                            </TableHead>
                            <TableBody>
                                {
                                    patients.length > 0 ?
                                        (
                                            patients.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((patient) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>
                                                            <LoadingButton
                                                                className={styles.textbutton}
                                                                loading={
                                                                    loaderArray.indexOf(patient.Patient_N) > -1
                                                                }
                                                                loadingPosition="center"
                                                                loadingIndicator={
                                                                    <CircularProgress
                                                                        size={20}
                                                                        style={{ color: "#083A4D" }}
                                                                    />
                                                                }
                                                                onClick={() => LoadPatientInfo(patient)}
                                                            >
                                                                {loaderArray.indexOf(patient.Patient_N) > -1 ? "" : patient.PatientLastName}
                                                            </LoadingButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            {patient.PatientFirstName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {patient.PatientDOB != null ? new Date(patient.PatientDOB).toLocaleDateString() + "" : ""}
                                                        </TableCell>
                                                        {/* FB 8204 BEGIN */}
                                                        <TableCell>
                                                            {patient.Patient_N}
                                                        </TableCell>
                                                        {/* FB 8204 BEGIN */}
                                                        <TableCell style={{ textTransform: "capitalize" }}>
                                                            {patient.PatientGender}
                                                        </TableCell>
                                                        <TableCell>
                                                            {patient.PatientEmail}
                                                        </TableCell>
                                                        <TableCell>
                                                            {patient.PatientCellPhone}
                                                        </TableCell>
                                                        <TableCell>
                                                            {/* FB 7874 */}
                                                            <Tooltip title="Reset Password" placement="top-start">
                                                                <IconButton
                                                                    onClick={() => ResetPassword(patient)}
                                                                >
                                                                    <LockResetOutlined style={{ color: "#18a2b8" }} />
                                                                </IconButton>
                                                            </Tooltip>

                                                            <Tooltip title="Disable patient" placement="top-start">
                                                                <IconButton
                                                                    onClick={() => DisablePatients(patient)}
                                                                >
                                                                    <RemoveCircleOutline style={{ color: "red" }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) :
                                        <TableRow>
                                            <TableCell style={{ textAlign: "center", backgroundColor: "lightgray" }}>
                                                <b>No records found!</b>
                                            </TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box
                        sx={{
                            flexGrow: 1,
                            paddingTop: 2,
                            paddingBottom: 2,
                            display: patients.length > 0 ? "block" : "none"
                            //maxWidth: matches == false ? "inherit" : "90%",
                        }}
                    >
                        <Grid container>
                            <Grid item xs={8} display="flex">
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <span className={styles.TablePagination_text}>
                                            Show{" "}
                                        </span>
                                    </Grid>
                                    <Grid item>
                                        <select
                                            value={rowsPerPage}
                                            onChange={(e) => handleChangeRowsPerPage(e)}
                                            style={{
                                                color: "#083A4D",
                                                borderRadius: "5px",
                                                padding: "8px, 16px, 8px, 16px",
                                            }}
                                        >
                                            {rowsArray.map((rows) => (
                                                <option value={rows}>{rows}</option>
                                            ))}
                                        </select>
                                    </Grid>
                                    <Grid item>
                                        <span className={styles.TablePagination_text}>
                                            {" "}
                                            per page
                                        </span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4} className={styles.flexend_Grid}>
                                <IconButton
                                    onClick={() => setPage(page - 1)}
                                    disabled={page === 0}
                                    style={{ color: page === 0 ? "" : "#083A4D" }}
                                >
                                    <PlayCircleOutlineIcon
                                        style={{ transform: "rotate(180deg)" }}
                                    />
                                </IconButton>
                                <IconButton
                                    onClick={() => setPage(page + 1)}
                                    disabled={
                                        page >=
                                        Math.ceil(
                                            (patients ? patients.length : 0) / rowsPerPage
                                        ) -
                                        1
                                    }
                                    style={{
                                        color:
                                            page >=
                                                Math.ceil(
                                                    (patients ? patients.length : 0) / rowsPerPage
                                                ) -
                                                1
                                                ? ""
                                                : "#083A4D",
                                    }}
                                >
                                    <PlayCircleOutlineIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            {/* FB 7874 - Start */}
            <Dialog
                open={open}
                onClose={() => { setOpen(false) }}
                //maxWidth="lg"
                //fullWidth
                fullScreen
            >
                <DialogContent style={{ overflow: "hidden", height: "85vh" }}>
                    <iframe src="/user/home/dashboard" style={{ width: "100%", height: "80vh" }} />
                </DialogContent>
                <DialogActions>
                    <Button
                        className={styles.textbutton}
                        onClick={() => { setOpen(false); }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <ThemeProvider theme={theme}>
                <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
                    <DialogContent
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress style={{ color: "#083A4D" }} />
                    </DialogContent>
                </Dialog>
            </ThemeProvider>
            <Dialog
                open={openResetDialog}
                onClose={() => { setOpenResetDialog(false) }}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    <Settings userType="admin" />
                </DialogContent>
                <DialogActions>
                    <Button
                        className={styles.textbutton}
                        onClick={() => { setOpenResetDialog(false); }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FB 7874 - End */}
        </Box >
    )
}